module.exports = __webpack_public_path__ + "img/weituoBg.54e5bc62.png";